import { useFetchTable } from "@hooks/useFetchDataTable";
import { ServicesURL } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import { useLocation, useParams } from "react-router-dom";
import React, { useEffect } from "react";
import { RadioCst } from "@components/InputCst";
import Table from "@components/Table";
import { useSkillBookState } from "@pages/Contents/BadgeAndCertificates/context/SkillBookContext";
import { Step1Props } from "@pages/Contents/BadgeAndCertificates/types";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useFilters } from "@context/filters";
import { useAuth } from "@context/auth";
import CheckboxCst from "@components/InputCst/CheckboxCst";

const Step1: React.FC<Step1Props> = ({ errors }) => {
  const { t } = useTranslation("skillBook-page");
  const theme = useTheme();
  const { state, dispatch } = useSkillBookState();
  const { id } = useParams();
  const location = useLocation();
  const { filters } = useFilters();
  const { user } = useAuth();
  const filterId = `${user?.id_user}_${PagesID["skillBook"] + location.pathname}`;

  const { columns, dataTable, actionsTopToolbar } = useFetchTable(
    `${ServicesURL.getCustomer}?corporate_id=${id}`,
    PagesID["skillBook-users"],
    filters[filterId],
  );

  const customRenderRowActions = ({ row }: { row: any }): React.ReactNode => {
    return [
      <CheckboxCst
        key={row.original.id}
        id={row.original.id}
        value={state.usersIdList?.includes(row.original.id_user)}
        onChange={() => {
          const id = row.original.id_user;
          const usersIdList = state.usersIdList ?? [];
          const newValue = usersIdList.includes(id)
            ? usersIdList.filter((x: number) => x !== id)
            : [...usersIdList, id];
          dispatch({
            type: "SET_INPUT_VALUES",
            payload: { key: "usersIdList", value: newValue },
          });
        }}
        options={[{ value: state.usersIdList?.includes(row.original.id_user) }]}
      />,
    ];
  };

  return (
    <>
      <Typography sx={{ padding: "16px 0 16px 24px" }}>
        {state.usersIdList?.length
          ? t("selected_users").replace("%ids", state.usersIdList.join(", "))
          : t("no_selected_users")}
      </Typography>

      {dataTable?.output && (
        <Table
          id={PagesID["skillBook"] + location.pathname}
          data={dataTable?.output || []}
          columns={columns || []}
          configurationTopToolbar={actionsTopToolbar}
          renderRowActions={customRenderRowActions}
          totalPages={dataTable?.metadata?.total_elements}
        />
      )}
      {errors && errors.user_id && (
        <Box
          sx={{
            marginTop: "10px",
            color: theme.palette.primary.main,
          }}
        >
          {t(`validation.${errors.user_id}`)}
        </Box>
      )}
    </>
  );
};

export default Step1;
